import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BizDataGridDirective } from 'src/app/shared/grid/biz-grid.directive';
import { DataFieldChoice } from '../models/data-field';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective as BizDataGridDirective_1 } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoGroupPanelModule, DxiColumnModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';

@Component({
    selector: 'app-developer-data-field-choices',
    templateUrl: './developer-data-field-choices.component.html',
    styleUrls: ['./developer-data-field-choices.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective_1, DxoEditingModule, DxoGroupPanelModule, DxiColumnModule, DxiValidationRuleModule]
})
export class DeveloperDataFieldChoicesComponent implements OnInit {
  @ViewChild(BizDataGridDirective, { static: true }) dataGrid: BizDataGridDirective;

  @Input() choices: DataFieldChoice[] = [];

  constructor(
    public modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  onInitNewRow(e: any): void {
    e.data = {
      SortOrder: 0,
      Value: '',
      DisplayValue: '',
      IsDefault: false,
    } as DataFieldChoice;
  }

  onRowInserted(e: any): void {
    const choice = e.data as DataFieldChoice;
    this.ensureOneDefault(choice);
  }

  onRowUpdated(e: any): void {
    const choice = e.data as DataFieldChoice;
    this.ensureOneDefault(choice);
  }

  onRowRemoved(e: any): void {
    this.ensureOneDefault();
  }

  ensureOneDefault(updatedChoice?: DataFieldChoice): void {
    if (updatedChoice?.IsDefault) {
      this.choices.forEach(e => {
        e.IsDefault = false;
      });
      updatedChoice.IsDefault = true;
    }
    else {
      if (this.choices.length > 0) {
        const defaults = this.choices.filter(e => e.IsDefault);
        if (defaults.length === 0) {
          this.choices[0].IsDefault = true;
        }
        else {
          defaults.splice(0, 1);
          defaults.forEach(e => e.IsDefault = false);
        }
      }
    }
  }

  ok(): void {
    this.modal.close(this.choices);
  }

  cancel(): void {
    this.modal.dismiss();
  }
}
